const ITEMS = [
  "Dock-to-Door Freight",
  "3,000 LB Hydraulic Lift Gate",
  "Greater Phoenix Metro",
  "All 15 Arizona Counties",
  "Palletized Cargo",
  "Same-Day & Scheduled Delivery",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display italic text-2xl sm:text-3xl text-[#E6DACB]/70 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-[#C85A32] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="marquee-ribbon"
    aria-hidden="true"
    className="relative border-y border-[#C85A32]/25 bg-[#281D17] py-6 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);
